export const APP_NAME = 'sharing-panel';
export const COPY_LINK_KEY = 'link';
export const EMOTION_CACHE_KEY = `${APP_NAME}-emotion-cache-key`;
export const SHOW_ALL_VENDORS_KEY = `${APP_NAME} show all vendors`;
export const VENDOR_DATA_ATTRIBUTE = 'data-vendor';
//# sourceMappingURL=constants.js.map